import React from 'react'
import {
    Box,
    Text,
    Button,
} from "grommet"


const TTabSub = ({
    subTabName,
    selected,
    handleClickSubTab,
    defaultColor = 'light-2',
    selectedColor = 'light-3',
    invert = false,
    showDiagIcon = false,
    diagAlert = false
}) => {

    let selectColor = selectedColor
    let unselectedColor = defaultColor

    if (invert) {
        selectColor = defaultColor
        unselectedColor = selectedColor
    }

    return (
        <Box
            border={selected ? 'vertical' : 'all'}
            background={selected ? selectColor : unselectedColor}
        >
            <Box
                direction="row"
                gap="small"
                border={{ side: "top", color: selected ? "brand" : "dark-3", size: "medium" }}
                fill
            />
            <Button plain fill label={
                <Box direction='row' align="center" justify="start" alignContent="start">
                    {showDiagIcon && !diagAlert && <Text color="ttdown" size="xsmall">✅</Text>}
                    {showDiagIcon && diagAlert && <Text color="ttdown" size="xsmall">❌</Text>}
                    <Text
                        size="small"
                        margin="2px"
                        color={selected ? "brand" : "dark-3"}
                        truncate={selected ? false : "tip"}
                        tip={{
                            content: <Text size="xsmall" color="white">{subTabName}</Text>,
                            dropProps: {
                                align: { top: 'bottom' },
                                background: "black",
                                pad: "xsmall",
                            },
                            plain: true,
                        }}
                    >
                        {subTabName}
                    </Text>
                </Box>
            }
                margin={{ top: "xxsmall", left: "xsmall", right: "xsmall" }}
                pad={{ left: "30px" }}
                hoverIndicator={{ color: "light-1", opacity: "weak" }}
                onClick={handleClickSubTab} />
        </Box>
    )
}

export default TTabSub
